<template>
    <Navbar />
    <v-container fluid class="px-md-13 mt-10">
        <v-row>
            <!-- {{ cardIdFromRoute }} <br>
            serviceDetailId: {{ serviceDetailId }} <br>
            <br> -->

            <!-- {{ serviceTypeCards }} -->
            <!-- Left Section: Product Selection with Main Image -->
            <v-col cols="12" md="4" sm="12">
                <div v-if="serviceTypeCards">
                    <!-- Main Product Image Display with Carousel -->
                    <v-carousel v-model="selectedColorIndex" hide-delimiters show-arrows
                        style="height: auto !important">
                        <v-carousel-item v-for="(option, index) in serviceTypeCards.service_images" :key="index"
                            class="main-image-container">
                            <v-img :src="option" contain class="main-img">
                                <!-- <v-img :src="'http://192.168.1.83:8002' + option" contain class="main-img"> -->
                                <!-- <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template> -->
                            </v-img>
                        </v-carousel-item>
                    </v-carousel>

                    <!-- Thumbnail Selector - Horizontal Scrollable -->
                    <div class="thumbnail-container">
                        <div class="thumbnail-scroller" ref="thumbnailScroller">
                            <div v-for="(option, index) in serviceTypeCards.service_images" :key="index"
                                class="thumbnail-item" :class="{ 'active-thumbnail': index === selectedColorIndex }"
                                @click="selectColor(index)" :ref="(el) => (thumbnailRefs[index] = el)">
                                <v-img :src="option" class="thumbnail-img test" :aspect-ratio="3 / 2" contain>

                                    <template v-slot:placeholder>
                                        <v-row class="fill-height ma-0" align="center" justify="center">
                                            <v-progress-circular indeterminate color="grey lighten-5"
                                                size="20"></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                                <div class="thumbnail-label">{{ option.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-col>

            <!-- Middle Section: Product Details -->
            <v-col cols="12" md="4" sm="12">
                <div v-if="serviceTypeCards" class="ma-md-9">
                    <h2 class="text-h5 font-weight-bold mb-2">{{ serviceTypeCards.title }}</h2>
                    <p class="text-subtitle-2 font-weight-bold mb-3" style="color: #5761e7">
                        Rs. {{ serviceTypeCards.current_price }}
                    </p>
                    <p class="text-body-2">
                        {{ serviceTypeCards.sub_title }}
                    </p>
                    <p v-html="serviceTypeCards.description" class="text-body-2"></p>
                    <!-- <span v-html="serviceTypeCards.description" class="text-body-2"></span> -->

                    <!-- <v-row v-for="(item, index) in PrintingType" :key="index" class="align-center" no-gutters>
                        <v-col cols="4" sm="4" md="5" class="text-body-1"><strong>{{ item.label }}</strong></v-col>
                        <v-col cols="1" sm="1" class="text-center">:</v-col>
                        <v-col cols="7" sm="4" md="6" class="">{{ item.value }}</v-col>
                    </v-row> -->
                </div>
                <div v-else>
                    <p>Card not found!</p>
                </div>
            </v-col>

            <!-- Right Section: Order Summary -->
            <v-col cols="12" md="3" sm="12" class="order_summary px-md-4 ml-md-4 elevation-2" style="color: white">
                <h2 class="text-h5 font-weight-bold mb-3">Order Summary</h2>
                <div class="quantity-wrapper" style="max-width: 400px">
                    <h4 class="font-weight-bold mb-3 text-white">Quantity :</h4>
                    <v-text-field v-model="quantity" type="number" :min="serviceTypeCards?.min_quantity || 50" outlined dense variant="plain" hide-details
                        class="custom-quantity-input text-black p-2" style="background-color: white" />
                    <!-- <v-text-field v-model="quantity" type="number" min="50" outlined dense variant="plain" hide-details
                        class="custom-quantity-input text-black p-2" style="background-color: white" /> -->
                    <!-- <v-text-field 
  v-model="quantity" 
  type="number" 
  min="50" 
  variant="plain"
  density="compact"
  hide-details
  class="custom-quantity-input text-black"
  style="background-color: white"
/> -->

                    <p class="text-body-4">Minimum qty is {{ serviceTypeCards?.min_quantity }} pic.</p>
                </div>
                <v-divider class="my-3"></v-divider>
                <p class="text-body-1">
                    <strong>Total:</strong> <br />
                    <span>Rs. {{ total }}</span> <br />
                    <span class="fs-7">Include of all taxes</span>
                </p>
                <!-- <p class="fs-6">
                    Include of all taxes
                </p> -->

                <v-btn color="primary" class="white--text mt-4" block @click="addItemToCart()">Add to Cart</v-btn>
            </v-col>
        </v-row>
    </v-container>

    <!-- Description -->
    <v-container>
        <v-row v-if="serviceTypeCards" class="d-flex flex-column justify-center align-center">
            <v-col cols="12" sm="6" md="10" class="d-flex flex-column">
                <h2 class="text-h5 font-weight-bold mb-2"> DESCRIPTION </h2>
                <p class="text-body-2">
                    {{ serviceTypeCards.short_description }}
                </p>
            </v-col>
        </v-row>
    </v-container>

    <!-- Similar product -->
    <v-container>
        <v-row class="d-flex flex-column justify-center align-center">
            <v-col cols="12" sm="6" md="10" class="d-flex flex-column">
                <h2 class="text-h5 font-weight-bold mb-2">Similar Products</h2>
                <Product />
                <section class="section-spacing">
                    <HowWork />

                </section>

                
            </v-col>
        </v-row>
    </v-container>

<WhyUs />
<!-- <section class="section-spacing"> -->

                    <Footer />
                <!-- </section> -->
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { defineProps } from "vue";
import { defineAsyncComponent } from "vue";
import { useCartStore } from "@/Store/cartStore";
import { cards } from "@/Store/data/cards.js";
import { useRoute } from "vue-router";
import { serviceIdCard } from '@/services/apiServices.js'
import Navbar from "@/components/Navbar.vue";
import Product from "@/components/HomeCompoent/Product.vue";
import Footer from "@/components/SharedUI/Footer.vue";
import { apiConfig } from "@/config/apiConfig";
import banner1 from "@/assets/images/administrator.jpg";

const HowWork = defineAsyncComponent(() =>
    import("@/components/HomeCompoent/HowWork.vue")
);
const WhyUs = defineAsyncComponent(() =>
    import("@/components/HomeCompoent/WhyUs.vue")
);

import mainImage from "@/assets/images/id_detail.png";
import imageSecond from "@/assets/images/id_detail_2.png";
import imageThird from "@/assets/images/id_detail_3.png";
import imageForth from "@/assets/images/id_detail_4.png";
import imageFifth from "@/assets/images/id_detail_5.png";
import imageSixth from "@/assets/images/id_detail_6.png";


// const getImage = (item) => {
//     return item
//         ? `${apiConfig.imageUrl}/${item}`
//         : banner1;
// };
// import { getCurrentInstance } from 'vue';
// const { appContext } = getCurrentInstance();
// const getImage = appContext.config.globalProperties.$getImage;
const props = defineProps({
    id: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
});
const error = ref(null);
const currentIndex = ref(0);
const quantity = ref(null);
const visibleCount = 3;

// const card = ref(null);
const cardTitle = ref(null);
const cardId = ref();
const showDialog = ref(false);
const selectedColorIndex = ref(0);
const descriptionTitle = ref("DESCRIPTION");
const route = useRoute();
const serviceTypeCards = ref([]);
// const cardIdFromRoute = parseInt(route.params.id);
// const serviceDetailId = route.params.id;



const thumbnailRefs = ref([]);
const thumbnailScroller = ref(null);

const cartStore = useCartStore();
const { addToCart } = useCartStore();

const scrollToActiveThumbnail = () => {
    const activeThumbnail = thumbnailRefs.value[selectedColorIndex.value];
    if (activeThumbnail) {
        activeThumbnail.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest",
        });
    }
};

// Set quantity to min_quantity when serviceTypeCards is available
watch(
  () => serviceTypeCards.value,
  (newVal) => {
    if (newVal && newVal.min_quantity) {
      quantity.value = newVal.min_quantity
    }
  },
  { immediate: true }
)

watch(selectedColorIndex, () => {
    scrollToActiveThumbnail();
});

const cardIdFromRoute = ref(parseInt(route.params.id));
const serviceDetailId = ref(route.params.id);

// ✅ Now this will work
watch(() => route.params.id, (pId) => {
    // console.log("Route param changed:", pId);
    cardIdFromRoute.value = pId;
    serviceDetailId.value = pId;

    fetchServiceDetails(pId);
});

function fetchServiceDetails(id) {
    console.log("Fetching data for ID:", id);
    // ...your API or logic here
}
const fetchServiceIdCard = async () => {
    try {
        const data = await serviceIdCard(cardIdFromRoute.value, serviceDetailId.value);
        // console.log("Service Type Cards:", data);
        serviceTypeCards.value = data;
        // console.log("Service Type Cards:", serviceTypeCards.value);
    } catch (err) {
        error.value = err.response?.data?.message || "Failed to load services";
        console.error("Error fetching service details:", err);
    }
};





const total = computed(() => {
    if (!serviceTypeCards.value) return 0;
    const price = parseFloat(
        // serviceTypeCards.value.current_price.replace("Rs ", "").replace("/pic", "")
        serviceTypeCards.value.current_price
    );
    const computedTotal = price * quantity.value;
    return computedTotal;
});

const selectColor = (index) => {
    selectedColorIndex.value = index;
    scrollToActiveThumbnail();
};

const addItemToCart = () => {
    const product = serviceTypeCards.value;

    if (!product) return;

    const qty = quantity.value;
    const basePrice = parseFloat(product.current_price);
    const subTotal = qty * basePrice;

    cartStore.addToCart(product, qty, subTotal);
}


onMounted(async () => {
    await fetchServiceIdCard(); // this sets serviceTypeCards.value
    cardTitle.value = serviceTypeCards.value.title;
    cardId.value = serviceTypeCards.value.id;

    cartStore.loadCartFromLocalStorage();
    scrollToActiveThumbnail();
});


// const nextCard = () => {
//     if (currentIndex.value + visibleCount < cards.length) {
//         currentIndex.value++;
//     }
// };

// const previousCard = () => {
//     if (currentIndex.value > 0) {
//         currentIndex.value--;
//     }
// };
</script>

<style scoped>
/* Main Image Container */
.main-image-container {
    position: relative;
    overflow: hidden;
    background: #f8f8f8;
    border-radius: 12px;
    transition: all 0.3s ease;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.main-image-container:hover {
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.main-img {
    width: 100%;
    height: 300px;
    object-fit: contain;
    transition: transform 1.5s ease;
}

.main-image-container:hover .main-img {
    transform: scale(1.02);
}

/* Thumbnail Container */
.thumbnail-container {
    width: 100%;
    height: 100px;
    overflow-x: auto;
    padding-bottom: 8px;
    scroll-behavior: smooth;
    /* margin-top: -210px; */
}

.thumbnail-scroller {
    display: flex;
    gap: 12px;
    padding: 4px 0;
}

.thumbnail-item {
    position: relative;
    min-width: 80px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
    border: 2px solid transparent;
    flex-shrink: 0;
}

.thumbnail-item:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.active-thumbnail {
    border-color: #5761e7;
    box-shadow: 0 4px 12px rgba(87, 97, 231, 0.3);
}

.thumbnail-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: #f1f1f1;
}

.thumbnail-label {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    color: white;
    font-size: 10px;
    text-align: center;
    padding: 2px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Custom scrollbar for thumbnails */
.thumbnail-container::-webkit-scrollbar {
    height: 4px;
}

.thumbnail-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.thumbnail-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
}

.thumbnail-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.order_summary {
    top: 20px;
    padding: 2rem;
    background: linear-gradient(to bottom right, #5761e7, #f0dfdd);
    border-radius: 15px;
    height: fit-content;
}

.order_summary h2 {
    color: #fff;
    font-size: 1.6rem;
}

.quantity-wrapper {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
}

.custom-quantity-input {
    background-color: #f1f1f1;
    font-weight: bold;
    border-radius: 12px;
    border: none !important;
    box-shadow: none !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
    .main-image-container {
        height: 350px;
    }

    .thumbnail-item {
        min-width: 70px;
        width: 70px;
        height: 70px;
    }
}

@media (max-width: 600px) {
    .main-image-container {
        height: 300px;
    }

    .thumbnail-item {
        min-width: 60px;
        width: 60px;
        height: 60px;
    }

    .thumbnail-label {
        font-size: 8px;
    }
}

/* Transition effects */
.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
